import React, { Component } from 'react'
import { Card, Button } from 'antd'
import ReactEcharts from 'echarts-for-react';
import './line.less'

export default class Line extends Component {
    state = {
        name: ["內衣", "羊毛衫", "羽絨外套", "口罩", "高跟鞋", "襪子"],
        sales: [5, 20, 36, 10, 10, 20],
        stores: [50, 10, 2, 44, 48, 60]
    }

    update = () => {
        this.setState(state => ({
            sales: state.sales.map(sale => sale + 1),
            stores: state.stores.reduce((pre, store) => {
                pre.push((store - 1) >= 0 ? (store - 1) : 0)
                return pre
            }, []),
        }))

    }

    getOption = (name, sales, stores) => {
        return {
            title: {
                text: '商品銷售'
            },
            tooltip: {},
            legend: {
                data: ['銷量', '庫存']
            },
            xAxis: {
                data: name
            },
            yAxis: {},
            series: [{
                name: '銷量',
                type: 'line',
                data: sales
            },
            {
                name: '庫存',
                type: 'line',
                data: stores
            }
            ]
        }
    }

    render() {
        const { name, sales, stores } = this.state
        return (
            <div>
                <Card >
                    <Button type="primary" onClick={this.update}>更新數據</Button>
                </Card>
                <Card title='ECharts圖'>
                    <ReactEcharts option={this.getOption(name, sales, stores)} />
                </Card>
            </div>
        )
    }
}